<template>
  <div class="promoter-order" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">待核销订单</div>
          <div>
            <span class="num">{{ list.length }}</span>单
          </div>
        </div>
        <div class="iconfont icon-2"></div>
      </div>
    </div>

    <div class="list">
      <div class="item">
        <div class="listn">
          <div class="itenm" v-for="(item, index) in list" :key="index">
            <div class="top acea-row row-between-wrapper">
              <div class="pictxt acea-row row-between-wrapper">
                <div class="pictrue">
                  <img :src="item.avatar" />
                </div>
                <div class="text line1">{{ item.nickname }}</div>
              </div>
              <div class="money">
                销售提成：
                <span class="font-color-red">￥{{ item.xstc }}</span>
              </div>
            </div>
            <div class="bottom">
              <div>
                <span class="name">下单时间：</span>
                {{ item.order_time }}
              </div>
              <div>
                <span class="name">订单号：</span>
                {{ item.order_id }}
              </div>
              <div>
                <span class="name">购买项目：</span>
                {{ item.store_name }}
              </div>
              <div>
                <span class="name">支付金额：</span>
                {{ item.pay_price }}
              </div>
              <div>
                <span class="name">核销状态：</span>
                {{ status(item.is_hx) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
</style>
<script>
import { getBukeOrder } from "../../../api/yongjin";
import Loading from "@components/Loading";
export default {
  name: "DaihexiaoOrder",
  components: {
    Loading
  },
  data: function() {
    return {
      list: [],
      where: {
        page: 1,
        limit: 15
      },
      loaded: false,
      loading: false,
      loadTitle: "",
      count: 0
    };
  },

  mounted: function() {
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getIndex();
    });
  },

  methods: {
    status: function(status) {
      return status;
    },

    getIndex: function() {
      let there = this;
      if (there.loaded == true || there.loading == true) return;
      there.loading = true;
      getBukeOrder(there.where).then(
        res => {
          there.loading = false;
          there.loaded = res.data.list.length < there.where.limit;
          there.loadTitle = there.loaded ? "人家是有底线的" : "上拉加载更多";
          there.where.page = there.where.page + 1;
          there.list.push.apply(there.list, res.data.list);
          console.log(res.data);
        },
        error => {
          there.$dialog.message(error.msg);
        },
        300
      );
      there.loading = false;
    }
  }
};
</script>
